
import React from 'react';
import { UseQueryResult } from 'react-query';
import { Box, IconComponent, Spinner } from '@razorpay/blade/components';
import { BulkUploadDetailsSchemaContract } from 'schemas/BulkUploadDetailsSchema';
import { AppError } from 'utils/AppError';
import { ErrorCard } from 'components/BulkUploads/BladeComponents/ErrorCard';
import { FileUploadSection } from 'components/BulkUploads/BladeComponents/FileUploadSection';

export type FileUploadStepProps = {
  onNext: () => void;
  pollingRequestId: string;
  bulkUploadRecord: BulkUploadDetailsSchemaContract[0] | null;
  setBulkUploadRecord: (bulkUploadRecord: BulkUploadDetailsSchemaContract[0] | null) => void;
  bulkUploadRecordResponse: UseQueryResult<BulkUploadDetailsSchemaContract, typeof AppError>;
  errorCardProps?: {
    buttonText?: string;
    onClick?: () => void;
    showErrors?: boolean;
    buttonIcon?: IconComponent;
  };
};

export const FileUploadStep = ({
  pollingRequestId,
  bulkUploadRecord,
  setBulkUploadRecord,
  bulkUploadRecordResponse,
  errorCardProps = {},
}: FileUploadStepProps) => {
  const { isLoading, error } = bulkUploadRecordResponse;

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center">
        <Spinner accessibilityLabel="loading" />
      </Box>
    );
  }

  if (error) {
    return <ErrorCard error={error} {...errorCardProps} />;
  }

  return (
    <FileUploadSection
      title="2. Upload the updated sheet below👇"
      bulkUploadRecord={bulkUploadRecord}
      setBulkUploadRecord={setBulkUploadRecord}
      pollingRequestId={pollingRequestId}
    />
  );
};
